export const scraperService = {
  /**
   * Vérifier les informations d'un produit via scraping (mode asynchrone avec polling)
   */
  verifyProduct: async (productLink, platform, onProgress = null) => {
    if (onProgress) {
      onProgress({ elapsedTime: 0, attempt: 1, maxAttempts: 1 });
    }
    return {
      success: false,
      error:
        'Scraping: à implémenter via Cloud Functions (queue Firestore + worker), pas via API Express.',
      productInfo: null,
    };
  },
};

